<template>
    <div class="product-add">
        <!--form表单-->
        <el-form size="small" ref="form" :model="form" label-width="200px">
            <!--添加门店-->
            <div class="common-form">租赁协议</div>
            <el-form-item label="协议标题" prop="title" :rules="[{ required: true, message: ' ' }]">
                <el-input v-model="form.title" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="详情内容">
                <div>
                    <Uediter :text="form.text" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc" >
                    </Uediter>
                </div>
            </el-form-item>
            <el-form-item label="协议排序 " prop="sort" :rules="[{ required: true, message: ' ' }]">
                <el-input v-model="form.sort" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="协议开关 " prop="switch" :rules="[{ required: true, message: ' ' }]">
                <el-input v-model="form.switch" class="max-w460"></el-input>
                <div class="tips">协议开关(1:开、0:关)</div>
            </el-form-item>

            <!--提交-->
            <div class="common-button-wrapper">
                <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
            </div>


        </el-form>


    </div>
</template>
  
<script>
import SettingApi from '@/api/setting.js';
import Uediter from '@/components/UE2.vue';

export default {
    components: {
        /*编辑器*/
        Uediter
    },
    data() {
        return {
            loading: false,
            /*form表单数据*/
            form: {
                title: '',
                text: '',
                sort: '',
                switch: '',
                id:'',
                agreement_type:''
            },
            /*富文本框配置*/
            ueditor: {
                text: '',
                config: {
                    initialFrameWidth: 400,
                    initialFrameHeight: 500
                }
            },

        };
    },
    created() {
        this.getData();

    },

    mounted() {
         this.form.id = this.$route.query.id;
         this.form.agreement_type = this.$route.query.url;
    },
    methods: {
        /*获取富文本内容*/
        contentChangeFunc(e) {
            console.log(e,'e');
            this.form.text = e;
        },
        /*获取数据*/
        getData() {
            let self = this;
            // 取到路由带过来的参数
            const params = this.$route.query.id;
            SettingApi.contractDetail(
                {
                    id: params
                },
                true
            )
                .then(data => {
                    let detail = data.data.data;
                    console.log(detail,"detail");
                    // 将数据放在当前组件的数据内
                    self.form.title = detail.title;
                    self.form.text = detail.text;
                    // self.ueditor.text = detail.text;
                    self.contentChangeFunc(self.form.text)
                    self.form.sort = detail.sort;
                    self.form.switch = detail.switch;
                })
                .catch(error => { });
        },

        /*提交表单*/
        onSubmit() {
            let self = this;
            self.loading = true;
            let params = this.form;
            SettingApi.contracteDituser(params, true)
                .then(data => {
                    self.loading = false;
                    self.$message({
                        message: '恭喜你，修改成功',
                        type: 'success'
                    });
                    self.$router.push('/contract/contract/index');
                })
                .catch(error => {
                    self.loading = false;
                });
        },

    }
};
</script>
  
<style>
.tips {
    color: #ccc;
}
</style>
  


// WEBPACK FOOTER //
// src/views/contract/contract/edit.vue